module.exports = __webpack_public_path__ + "img/lms-fragentutor-search-question-top-logo.1bf3d66d.png";